import customAxios from "../serverCall";

const getReferralSettings = async () => {
  const response = await customAxios.get(`/admin/referral/settings`);
  return response;
};

const createReferralSettings = async (body) => {
  const response = await customAxios.post(`/admin/referral/settings/create`, body);
  return response;
};

const updateReferralSettings = async (body) => {
  const response = await customAxios.post(`/admin/referral/settings/update`, body);
  return response;
};

const ReferralService = {
  getReferralSettings,
  createReferralSettings,
  updateReferralSettings,
};

export default ReferralService;



